var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32966 11.995V3.9983C9.32966 3.64483 9.18924 3.30583 8.9393 3.05589C8.68935 2.80594 8.35036 2.66553 7.99688 2.66553H2.66578C2.31231 2.66553 1.97331 2.80594 1.72337 3.05589C1.47342 3.30583 1.33301 3.64483 1.33301 3.9983V11.3286C1.33301 11.5053 1.40322 11.6748 1.52819 11.7998C1.65316 11.9247 1.82266 11.995 1.9994 11.995H3.33217",
    stroke: "#155DFC",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9954 11.9949H5.99707",
    stroke: "#155DFC",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.661 11.9949H13.9938C14.1706 11.9949 14.34 11.9247 14.465 11.7997C14.59 11.6748 14.6602 11.5053 14.6602 11.3285V8.89623C14.6599 8.745 14.6082 8.59836 14.5136 8.4804L12.1946 5.58162C12.1322 5.50357 12.0532 5.44053 11.9632 5.39716C11.8732 5.35379 11.7747 5.3312 11.6748 5.33105H9.3291",
    stroke: "#155DFC",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3289 13.3277C12.0649 13.3277 12.6616 12.731 12.6616 11.9949C12.6616 11.2588 12.0649 10.6621 11.3289 10.6621C10.5928 10.6621 9.99609 11.2588 9.99609 11.9949C9.99609 12.731 10.5928 13.3277 11.3289 13.3277Z",
    stroke: "#155DFC",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66481 13.3277C5.40088 13.3277 5.99758 12.731 5.99758 11.9949C5.99758 11.2588 5.40088 10.6621 4.66481 10.6621C3.92873 10.6621 3.33203 11.2588 3.33203 11.9949C3.33203 12.731 3.92873 13.3277 4.66481 13.3277Z",
    stroke: "#155DFC",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9933,
    height: 15.9933,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTruck);
export default __webpack_public_path__ + "static/media/blue_truck.9bf60fdbff8c43eadc8b6efb2b439ad9.svg";
export { ForwardRef as ReactComponent };